import * as OM from '@/Model';
import store from '@/store';
import { CommonServices } from './CommonServices';

class _StorageServices {
    
    private readFromLocalStorage<T>(lsName: string): T | null {
        let data = window.localStorage.getItem(lsName);
        if(data){
            return JSON.parse(data);
        } else {
            return null;
        }
    }

    setRefreshTokenVM(refreshTokenVM: OM.RefreshTokenVM) {
        const loggedUser = store.state.user

        loggedUser.token = refreshTokenVM.token!
        loggedUser.refreshToken = refreshTokenVM.refreshToken!
        loggedUser.refreshTokenExpiryTime = refreshTokenVM.refreshTokenExpiryTime

        this.setLoggedUser(loggedUser)
        store.state.user = loggedUser
    }

    setLoggedUser(response: OM.LoggedUserVM) {
        CommonServices.setAuthToken(response.token)

        window.localStorage.setItem('loggedUser', JSON.stringify(response))
    }
    
    getLoggedUser() {
        return this.readFromLocalStorage<OM.LoggedUserVM>('loggedUser');
    }

}

export let StorageServices = new _StorageServices();